export const environment = {
  production: true,
  baseHref: '/',
  baseApi: 'https://veloxplus.cofen.app/api',
  keycloakRealm: 'vplus',
  keycloakClientId: 'velox-auth',
  keycloakUrl: 'https://sigen.cofen.gov.br/auth',
  rest: '/rest',
  camundaUrl: 'https://veloxplus.cofen.app/bpm',
  dashboardUrl: 'https://veloxplus.cofen.app/analytics/public/dashboard/ff1d5715-0f68-424e-974f-5ff39734581f',
  biUrl:'https://veloxplus.cofen.app/analytics',
  veloxAIApi: 'https://heroai.placeti.com.br/api',
  moodleUrl: 'https://academy.veloxplus.cofen.app',
};